import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

import { PRODUCT_SORT_VALUES } from '../constants/product'

export default function useNewCollectionSortV2(isStaticPage: boolean): {
  init: boolean
  baseSortBy: PRODUCT_SORT_VALUES
} {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.CLP_SORT_V2)
  useStatsigExperiment(STATSIG_EXPERIMENTS.TESTING_A_A_A)

  if (isStaticPage && experimentBucket) {
    if (experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CLP_SORT_V2].buckets?.groupA)
      return { init, baseSortBy: PRODUCT_SORT_VALUES.CLP_SORT_V2 }
  }
  return { init, baseSortBy: PRODUCT_SORT_VALUES.FEATURED }
}
